import React from 'react';
import { HERO_IMG, OFFER_ANCHOR } from '../data/constants';
import { coverage } from '../data/content';
const stats: Array<{
  value: string;
  label: string;
}> = [{
  value: '6',
  label: 'Modules Complets'
}, {
  value: '5',
  label: 'Bonus Stratégiques'
}, {
  value: 'Pro',
  label: 'Niveau Professionnel'
}, {
  value: 'Complet',
  label: 'Couverture Clinique'
}];
export function SystemSection() {
  return <section className="bg-petrol px-4 py-9 sm:px-6 sm:py-12" data-id="element-213" data-mp="31kz0kjqnxpl5">
      <div className="mx-auto grid max-w-6xl items-center gap-7 lg:grid-cols-2" data-id="element-214" data-mp="2wu0jhhxuongu">
        <div data-id="element-215" data-mp="2wrw5262bs62b">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-gold sm:text-xs" data-id="element-216" data-mp="2ws5zq6ybf1ec">
            Le système complet pour arrêter de tout recréer à chaque séance
          </p>
          <h2 className="mt-1.5 text-2xl font-extrabold text-white sm:text-4xl" data-id="element-217" data-mp="2iu7wnxpg2re5">
            Orthophonie Pro™
          </h2>
          <p className="mt-2.5 text-sm leading-snug text-cream/85 sm:text-base" data-id="element-218" data-mp="2dumn6tcnf0n6">
            Évaluation clinique, projets thérapeutiques, interventions structurées, séances prêtes à
            adapter, progressions, suivi et coordination. Tout est organisé pour vous permettre de
            sélectionner, adapter et utiliser rapidement les ressources pertinentes.
          </p>
          <dl className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-219" data-mp="z04u1tg54ok2">
            {stats.map(stat => <div key={stat.label} className="rounded-lg bg-white/10 px-2 py-3 text-center" data-id="element-220" data-mp="1mpz5c6kta527">
                <dt className="sr-only" data-id="element-221" data-mp="1roira6zenguk">{stat.label}</dt>
                <dd data-id="element-222" data-mp="1roagqlqr8nmj">
                  <span className="block font-display text-lg font-extrabold uppercase text-gold sm:text-xl" data-id="element-223" data-mp="1rmg3zupn01tj">
                    {stat.value}
                  </span>
                  <span className="mt-0.5 block font-display text-[9px] font-bold uppercase tracking-widest text-white/80" data-id="element-224" data-mp="1hp1n5tzsxb0p">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>

          <p className="mt-6 font-display text-[11px] font-bold uppercase tracking-[0.18em] text-gold sm:text-xs" data-id="element-225" data-mp="28xv46ucnsbw7">
            Une couverture complète pour votre pratique professionnelle
          </p>
          <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-226" data-mp="1z81s7s8lturf">
            {coverage.map(item => <li key={item} className="rounded-full border border-white/25 px-2.5 py-1 text-[11px] font-semibold text-cream sm:text-xs" data-id="element-227" data-mp="1u98go5cvodtw">
                {item}
              </li>)}
          </ul>
        </div>

        <a href={OFFER_ANCHOR} aria-label="Voir l’offre Orthophonie Pro" data-id="element-228" data-mp="1l78yh9q4n3pd">
          <img src={HERO_IMG} alt="Aperçu complet du système Orthophonie Pro avec ses six modules et cinq bonus" className="mx-auto w-full max-w-lg transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-229" data-mp="1ga8qgt9pvqvm" />
        </a>
      </div>
    </section>;
}